import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FilePreviewComponent } from './shared/file-preview';
import { ThemeService } from './services/theme';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FilePreviewComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('Arogyainsurance');
  private theme = inject(ThemeService);

  ngOnInit() {
    // Restore the saved accent at the ROOT, not in the layout shell: login, forgot-password
    // and the other pre-auth screens render outside the layout and would otherwise always
    // show the default blue. ThemeService.init() is SSR-safe.
    this.theme.init();
  }
}
